var map = {
  "./shape-heart-aquamarine-light.png": "15421",
  "./shape-heart-aquamarine.png": "78760",
  "./shape-heart-blue-gradient.png": "57971",
  "./shape-heart-blue-light.png": "89752",
  "./shape-heart-blue.png": "44406",
  "./shape-heart-cyan-gradient-1.png": "20339",
  "./shape-heart-cyan-gradient.png": "58133",
  "./shape-heart-cyan-light.png": "99481",
  "./shape-heart-cyan.png": "45075",
  "./shape-heart-green-gradient.png": "31498",
  "./shape-heart-green-light.png": "25081",
  "./shape-heart-green.png": "35394",
  "./shape-heart-grey100.png": "66316",
  "./shape-heart-grey1000.png": "93658",
  "./shape-heart-grey200.png": "45887",
  "./shape-heart-grey25.png": "19027",
  "./shape-heart-grey300.png": "41312",
  "./shape-heart-grey400.png": "22147",
  "./shape-heart-grey50.png": "65945",
  "./shape-heart-grey500.png": "20020",
  "./shape-heart-grey600.png": "37555",
  "./shape-heart-grey700.png": "61672",
  "./shape-heart-grey800.png": "99890",
  "./shape-heart-grey900.png": "10438",
  "./shape-heart-indigo-gradient.png": "18521",
  "./shape-heart-indigo-light.png": "69047",
  "./shape-heart-indigo.png": "43480",
  "./shape-heart-lime-gradient.png": "7890",
  "./shape-heart-lime-light.png": "40691",
  "./shape-heart-lime.png": "69620",
  "./shape-heart-magenta-gradient.png": "50479",
  "./shape-heart-magenta-light.png": "48092",
  "./shape-heart-magenta.png": "31339",
  "./shape-heart-navy-gradient.png": "98877",
  "./shape-heart-navy-light.png": "18648",
  "./shape-heart-navy.png": "78678",
  "./shape-heart-orange-gradient.png": "8952",
  "./shape-heart-orange-light.png": "80750",
  "./shape-heart-orange.png": "49913",
  "./shape-heart-purple-gradient.png": "38069",
  "./shape-heart-purple-light.png": "73443",
  "./shape-heart-purple.png": "80205",
  "./shape-heart-red-gradient.png": "39639",
  "./shape-heart-red-light.png": "86364",
  "./shape-heart-red.png": "76831",
  "./shape-heart-yellow-gradient.png": "39761",
  "./shape-heart-yellow-light.png": "8405",
  "./shape-heart-yellow.png": "52827"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97899;
